import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--text-secondary);

  .title {
    text-align: center;
    font-family: var(--font-bold);
    font-size: 18px;
  }
  .description {
    text-align: center;
    font-size: 14px;
  }
`;

const CommunityAdminContentCompetitorsNotification = () => {
  return (
    <Container>
      <span className={'title'}>Adding a community with no known company.</span>
      <span className={'description'}>
        If you want this community to be somebody else's competitor, open that community, then add this community from
        their competitor list.
      </span>
    </Container>
  );
};

export default CommunityAdminContentCompetitorsNotification;
